import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Institution from "./views/Institution.vue";
// loads Ireal as async component and with a code split point
import Ireal from "./views/Ireal.vue";
import Detail from "./views/Detail.vue";
import config from "./config";
import VueMeta from "vue-meta";

Vue.use(Router);
Vue.use(VueMeta);

export default new Router({
  base: config.publicPath,
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/ireal/:identifier",
      name: "ireal",
      component: Ireal,
      props: { emb: config.publicPath },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () =>
      //  import(/* webpackChunkName: "irealviewer" */ "./views/Ireal.vue")
    },

    {
      path: "/detail/:identifier",
      name: "detail",
      component: Detail,
    },
    {
      path: "/institution/:id",
      name: "institution",
      component: Institution,
    },
  ],
});
